<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    @if (isLoading) {
      <div class="skeleton-container">
        <div class="d-flex flex-column gap-3">
          <app-loading-box width="320" height="28"></app-loading-box>
          <app-loading-box width="620" height="20"></app-loading-box>
          <app-loading-box width="100%" height="72"></app-loading-box>
          <app-loading-box width="100%" height="180"></app-loading-box>
        </div>
      </div>
    } @else {
      <div class="title-wrapper">
        <div>
          <h1 class="title-default">Busca de NF-e na SEFAZ</h1>
          <p class="welcome-message">
            <button mat-icon-button type="button" aria-label="Voltar" (click)="cancelar()"><mat-icon>arrow_back</mat-icon></button>
            Defina como o sistema deve buscar e processar notas fiscais emitidas contra o seu CNPJ.
          </p>
        </div>
      </div>

      <app-alert-card type="info" icon="info">
        Estas configurações se aplicam a <strong>ambas as rotinas de entrada:</strong> o Painel de Notas Recebidas e a Central de Notas de Entrada.
      </app-alert-card>

      <form [formGroup]="form">
        <section class="section-container">
          <div class="section-title">
            <mat-icon class="material-symbols-outlined">task_alt</mat-icon>
            <span>Ciência da operação</span>
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isCienciaAutomatica" color="primary">
              Ativar ciência da operação automática
            </mat-slide-toggle>
            <span class="info-text">Quando ativo, o sistema registrará automaticamente o evento de “Ciência da Operação” para resumos de notas recebidas que ainda não possuem manifestação.</span>
          </div>
          @if (form.get('isCienciaAutomatica')?.value) {
            <app-alert-card type="warning" icon="warning">
              <strong>Atenção:</strong> ao fazer a ciência da operação de forma automática, você fica obrigado a fazer uma manifestação conclusiva na nota em até 180 dias, com risco de multa caso isso não seja feito.
            </app-alert-card>
          }
        </section>

        <section class="section-container">
          <div class="section-title">
            <mat-icon class="material-symbols-outlined">sync</mat-icon>
            <span>Busca automática na SEFAZ</span>
          </div>

          <div class="toggle-content">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isBuscaAutomatica" color="primary">
              Ativar busca automática na SEFAZ
            </mat-slide-toggle>
            <span class="info-text">Quando ativo, o sistema buscará novas notas automaticamente na SEFAZ seguindo o período escolhido.</span>
          </div>

          <div class="row">
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Período padrão para busca</mat-label>
                <mat-select formControlName="idPeriodoBuscaSefaz">
                  @for (periodo of periodos; track periodo.idPeriodoBuscaSefaz) {
                    <mat-option [value]="periodo.idPeriodoBuscaSefaz">{{ periodo.nome }}</mat-option>
                  }
                </mat-select>
                <mat-icon matSuffix class="help-icon-suffix" matTooltip="Este período determina de quanto em quanto tempo a busca automática das notas na SEFAZ será feita. Por padrão, ela ocorre diariamente à meia-noite e às 04:00 da manhã.">info_outline</mat-icon>
              </mat-form-field>
            </div>
          </div>
        </section>
      </form>
    }
  </div>
</div>

@if (!isLoading) {
  <div [matTooltip]="!podeAlterar ? 'Você não possui permissão para alterar esta configuração.' : ''">
    <app-footer-action
      [isLoadingSalvar]="isLoadingSalvar"
      [isSalvarDisabled]="!podeAlterar"
      salvarLabel="Salvar configurações"
      (cancelar)="cancelar()"
      (salvar)="salvar()">
    </app-footer-action>
  </div>
}
